<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART & HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Education</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Master of Arts (Economics)</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Geography</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Hindi</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in History</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Philosophy</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Psychology</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Public Administration</td>
                        </tr>
                        <tr>
                            <td class="time">Master of Arts in Sociology</td>
                        </tr>


                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Education</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts (Economics) </b>
                    – The Master of Arts (Economics) program at ARNI School of Art & Humanities provides students with
                    an in-depth understanding of economic theory, policy, and practice. The program is structured to
                    build foundational knowledge in economics, followed by advanced studies in various specialized areas
                    of economics.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Microeconomic Theory</li>
                    <li> Macroeconomic Theory</li>
                    <li> Indian Economy</li>
                    <li> Quantitative Methods for Economics</li>
                    <li> Mathematics for Economics</li>
                    <li> Elective I (Public Economics, Financial Economics, Econometrics)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Statistics</li>
                    <li> Open-Economy Macroeconomics</li>
                    <li> Welfare Economics & General Equilibrium</li>
                    <li> Development Economics</li>
                    <li> Elective II (Public Economics, Financial Economics, Econometrics)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> International Economics</li>
                    <li> Indian Economic Policy</li>
                    <li> Development and Growth Theory</li>
                    <li> Elective III (Economics of Education, Rural Economics, International Finance and Banking, Time
                        Series Analysis)
                    </li>
                    <li> Elective IV (Economics of Education, Rural Economics, International Finance and Banking, Time
                        Series Analysis)
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> International Trade</li>
                    <li> Environmental Economics</li>
                    <li> Elective V (Industrial Organization, Computer Application in Economics, Games and Information,
                        Monetary Economics)
                    </li>
                    <li> Assignment/ Dissertation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Geography</b>
                    – The Master of Arts in Geography program at ARNI School of Art & Humanities is designed to offer
                    students comprehensive knowledge and analytical skills in physical, human, and environmental
                    geography. The curriculum emphasizes both theoretical understanding and practical applications,
                    preparing students for careers in urban planning, environmental consultancy, research, and academia.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Introduction to Geography and Basic
                    Concepts
                </p>
                <ul>
                    <li> Physical Geography I</li>
                    <li> Human Geography I</li>
                    <li> Geographical Techniques</li>
                    <li> Economic Geography</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Intermediate Geography and Analytical
                    Methods
                </p>
                <ul>
                    <li> Physical Geography II</li>
                    <li> Human Geography II</li>
                    <li> Geospatial Technology and Applications</li>
                    <li> Environmental Geography</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Specialized Topics and Geographic
                    Research
                </p>
                <ul>
                    <li> Regional Geography</li>
                    <li> Urban Geography</li>
                    <li> Environmental Management and Policy</li>
                    <li> Research Methods in Geography</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Advanced Topics and Dissertation
                </p>
                <ul>
                    <li> Advanced Geomorphology</li>
                    <li> Political Geography</li>
                    <li> Climate Change and Adaptation</li>
                    <li> Dissertation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Hindi</b>
                    – The Master of Arts in Hindi program at ARNI School of Art & Humanities aims to provide students
                    with a deep understanding of Hindi literature, language, and culture. The program offers a
                    combination of theoretical learning and practical application, fostering critical thinking,
                    creativity, and research skills essential for careers in teaching, translation, media, and cultural
                    research.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Introduction to Hindi Literature and
                    Linguistics
                </p>
                <ul>
                    <li> Hindi Language and Linguistics</li>
                    <li> Ancient Hindi Literature</li>
                    <li> History of Hindi Literature</li>
                    <li> Hindi Poetry I</li>
                </ul>
            </div>


            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Classical and Modern Hindi
                    Literature
                </p>
                <ul>
                    <li> Hindi Prose I</li>
                    <li> Modern Hindi Poetry</li>
                    <li> Literary Criticism in Hindi</li>
                    <li> Translation Studies</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Advanced Hindi Literature and
                    Research Methods
                </p>
                <ul>
                    <li> Hindi Drama and Theatre</li>
                    <li> Feminist Literature in Hindi</li>
                    <li> Research Methodology in Hindi Literature</li>
                    <li> Hindi Fiction</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Specialization and Dissertation
                </p>
                <ul>
                    <li> Contemporary Hindi Literature</li>
                    <li> Comparative Literature in Hindi</li>
                    <li> Hindi Journalism and Media</li>
                    <li> Dissertation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in History</b>
                    – The Master of Arts in History program at ARNI School of Art & Humanities is designed to provide
                    students with a comprehensive understanding of historical events, periods, and methodologies. The
                    program emphasizes critical thinking, research, and analysis, preparing students for careers in
                    education, research, archival work, and heritage management.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Foundations of History and
                    Historiography
                </p>
                <ul>
                    <li> Introduction to Historical Methods</li>
                    <li> Ancient Indian History</li>
                    <li> Medieval Indian History</li>
                    <li> Historiography</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Classical and Modern History
                </p>
                <ul>
                    <li> Modern Indian History (1700-1947)</li>
                    <li> World History (1450-1800)</li>
                    <li> Social and Cultural History of India</li>
                    <li> Colonialism and Imperialism</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Specialization in Regional and Global
                    History
                </p>
                <ul>
                    <li> History of the Indian National Movement</li>
                    <li> Global History in the 20th Century</li>
                    <li> Economic History of India</li>
                    <li> Environmental History</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Advanced Topics and Dissertation
                </p>
                <ul>
                    <li> Post-Independence Indian History (1947-present)</li>
                    <li> Theories of History</li>
                    <li> History and Public Memory</li>
                    <li> Dissertation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Philosophy </b>
                    – The Master of Arts in Philosophy program at ARNI School of Art & Humanities offers a rigorous
                    exploration of philosophical thought across different traditions and periods. The program is
                    designed to foster critical thinking, analytical skills, and the ability to engage with complex
                    philosophical texts. It prepares students for careers in academia, research, law, and public policy,
                    as well as for personal intellectual growth.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Introduction to Philosophy and
                    Classical Foundations
                </p>
                <ul>
                    <li> Ancient Greek Philosophy</li>
                    <li> Indian Philosophy I</li>
                    <li> Logic and Critical Thinking</li>
                    <li> Ethics I</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Middle Ages and Modern Philosophy
                </p>
                <ul>
                    <li> Medieval Philosophy</li>
                    <li> Modern Philosophy I</li>
                    <li> Epistemology</li>
                    <li> Philosophy of Mind</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Contemporary Philosophy and
                    Specialization
                </p>
                <ul>
                    <li> Modern Philosophy II</li>
                    <li> Philosophy of Science</li>
                    <li> Political Philosophy</li>
                    <li> Phenomenology and Existentialism</li>
                    <li> Elective III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Advanced Topics and Dissertation
                </p>
                <ul>
                    <li> Philosophy of Religion</li>
                    <li> Ethics II</li>
                    <li> Aesthetics and Philosophy of Art</li>
                    <li> Dissertation/Seminar</li>
                </ul>
            </div>


            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Philosophy </b>
                    – The Master of Arts in Psychology program at ARNI School of Art & Humanities offers an in-depth
                    study of psychological theories, research methodologies, and practical applications. The program
                    equips students with a comprehensive understanding of human behavior, mental health, and cognitive
                    processes, preparing them for careers in clinical psychology, counseling, research, and
                    organizational settings.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Introduction to Psychology and
                    Foundations
                </p>
                <ul>
                    <li> Introduction to Psychology</li>
                    <li> Research Methodology in Psychology</li>
                    <li> Cognitive Psychology</li>
                    <li> Social Psychology</li>
                    <li> Open Elective</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Biological and Developmental
                    Psychology
                </p>
                <ul>
                    <li> Biological Psychology</li>
                    <li> Developmental Psychology</li>
                    <li> Abnormal Psychology</li>
                    <li> Psychometrics and Psychological Assessment</li>
                    <li> Elective</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Advanced Topics in Psychology
                </p>
                <ul>
                    <li> Clinical Psychology</li>
                    <li> Health Psychology</li>
                    <li> Organizational Psychology</li>
                    <li> Psychology of Learning and Motivation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Specialized Topics and Dissertation
                </p>
                <ul>
                    <li> Neuropsychology</li>
                    <li> Forensic Psychology</li>
                    <li> Positive Psychology</li>
                    <li> Dissertation/Internship</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Public Administration </b>
                    – The Master of Arts in Public Administration program at ARNI School of Art & Humanities prepares
                    students for careers in public sector administration, governance, and policy-making. The program
                    offers a comprehensive understanding of the principles of public administration, governance
                    structures, public policy, and administrative law. Students will gain valuable skills in leadership,
                    management, and public policy analysis.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Foundations of Public Administration
                </p>
                <ul>
                    <li> Introduction to Public Administration</li>
                    <li> Administrative Theory</li>
                    <li> Public Policy and Governance</li>
                    <li> Constitutional Framework of India</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Organizational Structures and Public
                    Management
                </p>
                <ul>
                    <li> Public Personnel Administration</li>
                    <li> Public Financial Management</li>
                    <li> Comparative Public Administration</li>
                    <li> E-Governance</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Advanced Public Administration and
                    Policy Analysis
                </p>
                <ul>
                    <li> Administrative Law</li>
                    <li> Development Administration</li>
                    <li> Local Government and Rural Development</li>
                    <li> Public Sector Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Specialized Topics and Dissertation
                </p>
                <ul>
                    <li> Public Administration and Ethics</li>
                    <li> International and Comparative Public Administration</li>
                    <li> Crisis Management and Disaster Administration</li>
                    <li> Dissertation/Assignment</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts in Sociology </b>
                    – The Master of Arts in Sociology program at ARNI School of Art & Humanities provides students with
                    a comprehensive understanding of social structures, institutions, and dynamics. The program
                    emphasizes the development of critical thinking, research skills, and the application of
                    sociological theories to real-world issues. Students will explore various sociological perspectives,
                    cultural dynamics, and contemporary social problems, preparing them for careers in academia, social
                    research, policy-making, and social work.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Foundations of Sociology and
                    Sociological Theories
                </p>
                <ul>
                    <li> Introduction to Sociology</li>
                    <li> Classical Sociological Theories</li>
                    <li> Research Methods in Sociology</li>
                    <li> Social Stratification</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Sociological Approaches and Social
                    Structures
                </p>
                <ul>
                    <li> Contemporary Sociological Theories</li>
                    <li> Indian Society and Social Change</li>
                    <li> Political Sociology</li>
                    <li> Sociology of Religion</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Specialization in Social Issues and
                    Institutions
                </p>
                <ul>
                    <li> Urban Sociology</li>
                    <li> Sociology of Education</li>
                    <li> Gender and Society</li>
                    <li> Sociology of Health and Medicine</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Advanced Topics and Dissertation
                </p>
                <ul>
                    <li> Social Movements and Social Change</li>
                    <li> Globalization and Society</li>
                    <li> Criminology and Sociology of Law</li>
                    <li> Dissertation/Assignments</li>
                </ul>
            </div>

        </div>

    </div>
</section>
